const paymentSummery = [
    {
        id:1,
        date:"20 Sep, 2022",
        invoiceID:"Lec-2157",
        client :"Donald Risher",
        billed :"240.00",
        paymentType :"Google Pay"
        
    },
    {
        id:2,
        date:"12 Arl, 2022",
        invoiceID:"Lec-2153",
        client :"Brody Holman",
        billed :"390.00",
        paymentType :"Cash"
        
    },
    {
        id:3,
        date:"28 Mar, 2022",
        invoiceID:"Lec-2154",
        client :"Jolie Hood",
        billed :"440.00",
        paymentType :"Google Pay"
        
    },
    {
        id:4,
        date:"23 Aug, 2022",
        invoiceID:"Lec-2155",
        client :"Buckminster Wong",
        billed :"520.00",
        paymentType :"Google Pay"
        
    },
    {
        id:5,
        date:"18 Sep, 2022",
        invoiceID:"Lec-2156",
        client :"Howard Lyons",
        billed :"480.00",
        paymentType :"Cash"
        
    },
    {
        id:6,
        date:"12 Feb, 2022",
        invoiceID:"Lec-2157",
        client :"Howard Oneal",
        billed :"550.00",
        paymentType :"Google Pay"
        
    },
    {
        id:7,
        date:"30 Nov, 2022",
        invoiceID:"Lec-2158",
        client :"Jena Hall",
        billed :"170.00",
        paymentType :"Credit Card"
        
    },
    {
        id:8,
        date:"23 Sep, 2022",
        invoiceID:"Lec-2159",
        client :"Paki Edwards",
        billed :"720.00",
        paymentType :"Credit Card"
        
    },
    {
        id:9,
        date:"16 Aug, 2022",
        invoiceID:"Lec-2160",
        client :"James Diaz",
        billed :"820.00",
        paymentType :"Google Pay"
        
    },
    {
        id:10,
        date:"30 Nov, 2022",
        invoiceID:"Lec-2158",
        client :"Jena Hall",
        billed :"170.00",
        paymentType :"Credit Card"
        
    }
]

export {paymentSummery}